import { quizPalletes } from "constants/Constants";
import React from "react";

const QuizPallete = () => {
  return (
    <>
      <div className="d-flex flex-column ">
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "14px",
            color: "#000000",
          }}
        >
          Question Pallete
        </div>
        {quizPalletes.map((pallete) => {
          return (
            <>
              <div className="d-flex mt-2">
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    background: pallete.color,
                    borderRadius: "2px",
                  }}
                ></div>
                <div
                  className="mx-2"
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#000000",
                  }}
                >
                  {pallete?.title}
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default QuizPallete;
